/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsList } from "../../funcs/llmPromptsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListPromptsRequest$inboundSchema,
};

export const tool$llmPromptsList: ToolDefinition<typeof args> = {
  name: "llm-prompts-list",
  description: `List prompts

Returns a paginated list of prompts owned by the authenticated user.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
